import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import styles from './toggleSwitchStyles.scss';

const ToggleSwitch: React.FC<{
  checked: boolean;
  onChange: () => void;
  isLoading: boolean;
}> = ({ checked, onChange, isLoading }): React.ReactElement => {
  return (
    <div className={styles.container}>
      <div>
        <label className={classNames(styles.toggleSwitch, { [styles.pointerDisabled]: isLoading })}>
          <input
            className={styles.input}
            type="checkbox"
            checked={checked}
            onChange={onChange}
            disabled={isLoading}
          />
          <span className={styles.label} data-on="On" data-off="Off" />
          <span className={styles.handle} />
        </label>
      </div>
      {isLoading && <FontAwesomeIcon icon={faCircleNotch} spin />}
    </div>
  );
};

export default ToggleSwitch;
